var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2974 20.4359C10.186 20.4359 10.0746 20.3923 9.98739 20.3051C9.81784 20.1355 9.81784 19.8546 9.98739 19.685L18.9543 10.7181L9.98739 1.75116C9.81784 1.58161 9.81784 1.30062 9.98739 1.13107C10.1569 0.961518 10.4379 0.961518 10.6075 1.13107L19.8844 10.4081C20.054 10.5776 20.054 10.8586 19.8844 11.0281L10.6075 20.3051C10.5203 20.3923 10.4088 20.4359 10.2974 20.4359Z",
    fill: "#C8AFA7",
    stroke: "#C8AFA7",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53945 20.4359C3.42803 20.4359 3.31666 20.3923 3.22946 20.3051C3.05991 20.1355 3.05991 19.8546 3.22946 19.685L12.1964 10.7181L3.22946 1.75116C3.05991 1.58161 3.05991 1.30062 3.22946 1.13107C3.39901 0.961518 3.68 0.961518 3.84955 1.13107L13.1265 10.4081C13.296 10.5776 13.296 10.8586 13.1265 11.0281L3.84955 20.3051C3.76235 20.3923 3.65087 20.4359 3.53945 20.4359Z",
    fill: "#C8AFA7",
    stroke: "#C8AFA7",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu04);
export default __webpack_public_path__ + "static/media/icon-menu-04.37b3de5788b6084d189833e3476654af.svg";
export { ForwardRef as ReactComponent };